module.exports = __webpack_public_path__ + "img/wifi.164d2385.jpg";